/*eslint-disable */

import Push from 'push.js';
import {bus} from '@/main';
import {
  mapGetters
} from 'vuex';
import mobileMenuBar from '../mobile-menubar/';
// import { themeMixin } from '@/mixins/themeMixin';
// import themeToggle from '@/components/common/theme-toggle/index.vue';

export default {
  name: 'after-login-header',
  //  mixins: [themeMixin],
  components: {
    mobileMenuBar,
    // themeToggle
  },
  props: [],
  data () {
    return {
      active:false,
      showBtn:true,
      navOpen: false,
      isMobile:false,
      selfUsrInfoState:null,
      msgCounts:0
    }
  },
  computed: {
    ...mapGetters([
      'selfUserDetailGetters',
    ]),
    getSelfUsrInfoMethod() {
      return this.selfUsrInfoState = this.$store.getters.selfUserDetailGetters.data
    },
  },
  mounted () {
    this.$store.dispatch('getSelfUserInfoApiFun')
    bus.$on('showHeaderbtn', (data) => {
      this.showBtn = data;
    });
    bus.$on('updateMessageNotifications', (data) => {
      if(this.$route.name != "appointmentDetail") {
        if(data.totalUnreadCount > 0){
          if(Push.Permission.has()){
            Push.create(data.senderName, {
              body:data.message,
              timeout:4000,
              onClick: function () {
                  window.focus();
                  this.close();
              }
            })
            this.msgCounts = data.totalUnreadCount;
          }else{
            this.msgCounts = data.totalUnreadCount;
            // this.playSound(audioPlay);
          }
        }
      }
    });
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 1023;
    },
    logOutUser() {
      if ('BroadcastChannel' in self) {
        authChannel.postMessage({
          cmd: 'logout'
        })
      }
    },
    logout(){
      this.$store.dispatch('logout')
        .then(() => {
          this.logOutUser()
          this.$router.push('/');
        })
    },
  },
  created() {
    window.addEventListener('resize', this.onResize, {
      passive: true
    })
    this.onResize()
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, {
        passive: true
      })
    }
  },
  watch:{
    getSelfUsrInfoMethod() {
      return this.$store.getters.selfUserDetailGetters;
    },
  }
}